module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9676.cfa43d74.jpg";